import { UserAuthentication, UserToken } from '@core/models/domain/auth.domain';
import { 
  LoginRequest, 
  CreateSchoolAccountRequest, 
  ValidateCodeRequest, 
  ResetPasswordRequest, 
  SetPasswordRequest,
  ChangePasswordRequest
} from '@core/models/request/auth.request';
import { createAction, props } from '@ngrx/store';

// LOGIN
export const login = createAction(
    '[Auth] Login',
    props<{ request: LoginRequest }>()
);
export const loginSuccess = createAction(
    '[Auth] Login Success',
    props<{ authentication: UserAuthentication}>()
);
export const loginFailure = createAction(
    '[Auth] Login Failure',
    props<{ error: string }>()
);

// CREATE SCHOOL ACCOUNT
export const createSchoolAccount = createAction(
    '[Auth] Create School Account',
    props<{ request: CreateSchoolAccountRequest }>()
);
export const createSchoolAccountSuccess = createAction(
    '[Auth] Create School Account Success',
    props<{ token: UserToken }>()
);
export const createSchoolAccountFailure = createAction(
    '[Auth] Create School Account Failure',
    props<{ error: string }>()
);
export const resendValidationCode = createAction(
    '[Auth] Resend Validation Code',
);
export const resendValidationCodeSuccess = createAction(
    '[Auth] Resend Validation Code Success',
    props<{ token: UserToken }>()
);
export const resendValidationCodeFailure = createAction(
    '[Auth] Resend Validation Code Failure',
    props<{ error: string }>()
);

// VALIDATE CODE
export const validateCode = createAction(
    '[Auth] Validate Code',
    props<{ request: ValidateCodeRequest }>()
);
export const validateCodeSuccess = createAction(
    '[Auth] Validate Code Success',
    props<{ token: UserToken }>()
);
export const validateCodeFailure = createAction(
    '[Auth] Validate Code Failure',
    props<{ error: string }>()
);

// RESET PASSWORD REQUEST
export const requestPasswordReset = createAction(
    '[Auth] Reset Password',
    props<{ request: ResetPasswordRequest }>()
);
export const requestPasswordResetSuccess = createAction(
    '[Auth] Reset Password Success',
    props<{ token: UserToken }>()
);
export const requestPasswordResetFailure = createAction(
    '[Auth] Reset Password Failure',
    props<{ error: string }>()
);

// SET PASSWORD
export const setPassword = createAction(
    '[Auth] Set Password',
    props<{ request: SetPasswordRequest }>()
);
export const setPasswordSuccess = createAction(
    '[Auth] Set Password Success'
);
export const setPasswordFailure = createAction(
    '[Auth] Set Password Failure',
    props<{ error: string }>()
);

// CHANGE PASSWORD
export const changePassword = createAction(
    '[Auth] Change Password',
    props<{ request: ChangePasswordRequest }>()
);
export const changePasswordSuccess = createAction(
    '[Auth] Change Password Success'
);
export const changePasswordFailure = createAction(
    '[Auth] Change Password Failure',
    props<{ error: string }>()
);

// LOGOUT
export const logout = createAction('[Auth] Logout');

// REFRESH TOKEN (in-memory access token renewal via HttpOnly cookie)
export const refreshToken = createAction('[Auth] Refresh Token');
export const refreshTokenSuccess = createAction(
    '[Auth] Refresh Token Success',
    // Full refresh result: the account IDs let the reducer rebuild the authentication
    // object when the in-memory state was lost (e.g. after a failed hydration).
    props<{ token: UserToken }>()
);
export const refreshTokenFailure = createAction(
    '[Auth] Refresh Token Failure',
    props<{ error: string }>()
);

// HYDRATE (Restore state from storage)
export const hydrateAuth = createAction('[Auth] Hydrate');
export const hydrateAuthSuccess = createAction(
    '[Auth] Hydrate Success',
    props<{ authentication: UserAuthentication }>()
);
export const hydrateAuthFailure = createAction('[Auth] Hydrate Failure');

